import { GetUserResponse, UserAuthenticationState } from '@trustblock/types/user.types';
import { atom } from 'jotai';

export const isAuthenticatingAtom = atom(true);
export const userAuthenticationStateAtom = atom<UserAuthenticationState>(UserAuthenticationState.Visitor);
export const userAtom = atom<GetUserResponse | null>(null);
export const authErrorAtom = atom<string | null>(null);
export const accessTokenAtom = atom<string | null>(null);
